export default "__VITE_ASSET__CYJ4U4JT__"